// Loads Google AdSense's adsbygoogle.js exactly once per publisher client id.
// Returns a promise that resolves(true) when ready, resolves(false) when no
// client is configured (AdSense disabled), and rejects if the script fails
// (e.g. blocked by an ad blocker) — callers must swallow that so the app
// keeps working.
const loadedByClient = new Map();

export function loadAdSense(client) {
  if (!client) return Promise.resolve(false);
  if (loadedByClient.has(client)) return loadedByClient.get(client);

  const promise = new Promise((resolve, reject) => {
    window.adsbygoogle = window.adsbygoogle || [];
    const existing = document.querySelector('script[data-adsense-loader="true"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(true), { once: true });
      existing.addEventListener('error', () => reject(new Error('AdSense loader failed')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.dataset.adsenseLoader = 'true';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error('AdSense loader failed'));
    document.head.appendChild(script);
  });

  loadedByClient.set(client, promise);
  return promise;
}
